import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import api, { imageUrl } from "@/lib/api";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, testid = "image-upload", label = "Upload image" }) {
  const ref = useRef();
  const [loading, setLoading] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch { toast.error("Upload failed"); } finally { setLoading(false); }
  };

  return (
    <div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative w-28 h-28 rounded-2xl overflow-hidden border border-[#E5DEC9] group">
          <img src={imageUrl(value)} alt="" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange("")} data-testid={`${testid}-remove`}
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1"><X size={14} /></button>
        </div>
      ) : (
        <button type="button" onClick={() => ref.current?.click()} data-testid={`${testid}-button`}
          className="w-28 h-28 rounded-2xl border-2 border-dashed border-[#E5DEC9] flex flex-col items-center justify-center gap-1 text-[#9A9282] hover:border-[#1A3C2A] hover:text-[#1A3C2A] transition-colors">
          {loading ? <Loader2 className="animate-spin" size={20} /> : <><Upload size={20} /><span className="text-[10px] font-semibold">{label}</span></>}
        </button>
      )}
    </div>
  );
}
